import React, { Component } from 'react';
import 'antd/dist/antd.css';
import { Form, Select, Button, Input, DatePicker, Divider, Radio } from 'antd';
import axios from '../../utils/request';
import moment from 'moment';
import 'moment/locale/zh-cn';
import './SFCheck.css'

moment.locale('zh-cn');

const { Option } = Select;
let tenantId = "";
let errorMessage = "";

const formLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
};

export class SFCheck extends Component {
    formRef = React.createRef();

    constructor(props) {
        super(props);
        this.state = {
            isReady: false,
            isLoading: true,
            errorMessage: "",
            tenantId: "",
            userId: "",
            messageCode: "",
            lastClickTime: Date.now(),

            tjlxSource: [],
            bddSource: [],
            ldhtSource: [],
            sjfwztSource: [],
            oneChannelSource: [],
            twoChannelSource: [],
            twoChannelAllSource: [],

            showReferrer:false, //是否显示推荐人
            showElem:false //是否显示表单
        }

    };


    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        let commonParamater = urlParams.get("commonParamater");
        tenantId = urlParams.get("tenantId");
        this.state.messageCode = urlParams.get("messageCode");
        if (!commonParamater) {
            this.setState({ errorMessage: "commonParamater不存在！", isLoading: false, isReady: true });
            return;
        }
        console.log("标准系统参数", commonParamater, tenantId);
        this.state.commonParamater = commonParamater;
        this.state.tenantId = tenantId;
        if (tenantId != null && tenantId > 0) {
            this.checkData(tenantId, commonParamater);
        } else {
            this.setState({showElem:true});
            this.testLoadPage(tenantId, commonParamater);
        }
    };

    //本地测试数据
    testLoadPage = (tenantId, commonParamater) => {
        const params = {
            tenantId,
            commonParamater
        }
        var data = "{\"code\":\"200\",\"message\":\"\",\"data\":{\"TenantId\":null,\"UserId\":0,\"ApplyId\":null,\"PlanDate\":\"2022-01-05T00:00:00\",\"LastSubmissionChannel\":\"内部推荐\",\"ReferrerJobNumber\":null,\"ReferrerName\":null,\"Zggh\":null,\"Tjlx\":null,\"TjlxSource\":[{\"Text\":\"001\",\"Value\":\"1\",\"TextJson\":\"001\",\"IsActive\":\"1\",\"TraceInfo\":null},{\"Text\":\"002\",\"Value\":\"2\",\"TextJson\":\"002\",\"IsActive\":\"1\",\"TraceInfo\":null},{\"Text\":\"003 成都\",\"Value\":\"3\",\"TextJson\":\"003 成都\",\"IsActive\":\"1\",\"TraceInfo\":null},{\"Text\":\"004 上海\",\"Value\":\"4\",\"TextJson\":\"004 上海\",\"IsActive\":\"1\",\"TraceInfo\":null},{\"Text\":\"005 北京\",\"Value\":\"5\",\"TextJson\":\"005 北京\",\"IsActive\":\"1\",\"TraceInfo\":null}],\"Bdd\":null,\"BddSource\":[{\"Text\":\"001\",\"Value\":\"1\",\"TextJson\":\"001\",\"IsActive\":\"1\",\"TraceInfo\":null},{\"Text\":\"002\",\"Value\":\"2\",\"TextJson\":\"002\",\"IsActive\":\"1\",\"TraceInfo\":null},{\"Text\":\"003 成都\",\"Value\":\"3\",\"TextJson\":\"003 成都\",\"IsActive\":\"1\",\"TraceInfo\":null},{\"Text\":\"004 上海\",\"Value\":\"4\",\"TextJson\":\"004 上海\",\"IsActive\":\"1\",\"TraceInfo\":null},{\"Text\":\"005 北京\",\"Value\":\"5\",\"TextJson\":\"005 北京\",\"IsActive\":\"1\",\"TraceInfo\":null}],\"Ldht\":null,\"LdhtSource\":[{\"Text\":\"001\",\"Value\":\"1\",\"TextJson\":\"001\",\"IsActive\":\"1\",\"TraceInfo\":null},{\"Text\":\"002\",\"Value\":\"2\",\"TextJson\":\"002\",\"IsActive\":\"1\",\"TraceInfo\":null},{\"Text\":\"003 成都\",\"Value\":\"3\",\"TextJson\":\"003 成都\",\"IsActive\":\"1\",\"TraceInfo\":null},{\"Text\":\"004 上海\",\"Value\":\"4\",\"TextJson\":\"004 上海\",\"IsActive\":\"1\",\"TraceInfo\":null},{\"Text\":\"005 北京\",\"Value\":\"5\",\"TextJson\":\"005 北京\",\"IsActive\":\"1\",\"TraceInfo\":null}],\"Sjfwzt\":null,\"SjfwztSource\":[{\"Text\":\"001\",\"Value\":\"1\",\"TextJson\":\"001\",\"IsActive\":\"1\",\"TraceInfo\":null},{\"Text\":\"002\",\"Value\":\"2\",\"TextJson\":\"002\",\"IsActive\":\"1\",\"TraceInfo\":null},{\"Text\":\"003 成都\",\"Value\":\"3\",\"TextJson\":\"003 成都\",\"IsActive\":\"1\",\"TraceInfo\":null},{\"Text\":\"004 上海\",\"Value\":\"4\",\"TextJson\":\"004 上海\",\"IsActive\":\"1\",\"TraceInfo\":null},{\"Text\":\"005 北京\",\"Value\":\"5\",\"TextJson\":\"005 北京\",\"IsActive\":\"1\",\"TraceInfo\":null}],\"OneChannel\":null,\"TwoChannel\":null,\"OneChannelSource\":[{\"Text\":\"001\",\"Value\":\"1\",\"TextJson\":\"001\",\"IsActive\":\"1\",\"TraceInfo\":null},{\"Text\":\"002\",\"Value\":\"2\",\"TextJson\":\"002\",\"IsActive\":\"1\",\"TraceInfo\":null},{\"Text\":\"003 成都\",\"Value\":\"3\",\"TextJson\":\"003 成都\",\"IsActive\":\"1\",\"TraceInfo\":null},{\"Text\":\"004 上海\",\"Value\":\"4\",\"TextJson\":\"004 上海\",\"IsActive\":\"1\",\"TraceInfo\":null},{\"Text\":\"005 北京\",\"Value\":\"5\",\"TextJson\":\"005 北京\",\"IsActive\":\"1\",\"TraceInfo\":null}],\"TwoChannelSource\":[{\"Text\":\"001\",\"Value\":\"1\",\"TextJson\":\"1\",\"IsActive\":\"1\",\"TraceInfo\":null},{\"Text\":\"002\",\"Value\":\"2\",\"TextJson\":\"1\",\"IsActive\":\"1\",\"TraceInfo\":null},{\"Text\":\"003 成都\",\"Value\":\"3\",\"TextJson\":\"2\",\"IsActive\":\"1\",\"TraceInfo\":null},{\"Text\":\"004 上海\",\"Value\":\"4\",\"TextJson\":\"2\",\"IsActive\":\"1\",\"TraceInfo\":null},{\"Text\":\"005 北京\",\"Value\":\"5\",\"TextJson\":\"3\",\"IsActive\":\"1\",\"TraceInfo\":null}],\"Wgjsrq\":null}}";
        var jsonResult = JSON.parse(data);
        console.log("长鑫存储表单测试数据", jsonResult);
        let errorMessage = "";
        if (jsonResult.code == "200") {
            this.loadData(jsonResult);
        }
        else {
            errorMessage = "获取长鑫存储ID失败";
            this.setState({ isLoading: false, isReady: true, errorMessage });
        }
    };

    //校验数据，通过则显示表单，不通过立即关掉表单并提示
    checkData = (tenantId, commonParamater) => {
        const params = {
            tenantId,
            commonParamater
        }
        axios
            .get("/api/ChangXinCunChu/CheckData", { params: params })
            .then(res => {
                console.log("长鑫存储数据校验", res);
                let errorMessage = "";
                if (res.status == 200 && res.data.code == "200") {
                    this.loadPage(tenantId, commonParamater);
                }else if (res.status == 200 && res.data.code == "417") {
                    window.parent.postMessage(
                        {
                            msgCode: this.state.messageCode,
                            Code: 417,
                            TipAutoDisappear:0, //1自动消失;0手动消失
                            Message: res.data.message,
                            isClose: true,
                        },
                        '*'
                    );
                }
                else {
                    errorMessage = "数据校验异常";
                    this.setState({ isLoading: false, isReady: true, errorMessage });
                }

                this.setState({ isLoading: false, isReady: true, errorMessage });
            })
            .catch(reason => {
                console.log(reason);
                this.setState({ isLoading: false, isReady: true, errorMessage: "校验异常，请联系管理员！" });
            })
            .finally(
            );
    };

    //长鑫存储需求 https://service-bridge.recruit.italent.cn 
    loadPage = (tenantId, commonParamater) => {
        this.setState({showElem:true});
        const params = {
            tenantId,
            commonParamater
        }
        axios
            .get("/api/ChangXinCunChu/GetRequirements", { params: params })
            .then(res => {
                console.log("长鑫存储表单数据", res);
                let errorMessage = "";
                if (res.status == 200 && res.data.code == "200") {
                    var jsonResult = res.data;
                    this.loadData(jsonResult);
                }else {
                    errorMessage = "获取长鑫存储ID失败";
                    this.setState({ isLoading: false, isReady: true, errorMessage });
                }

                this.setState({ isLoading: false, isReady: true, errorMessage });
            })
            .catch(reason => {
                console.log(reason);
                this.setState({ isLoading: false, isReady: true, errorMessage: "加载异常，请联系管理员！" });
            })
            .finally(
            );
    };

    //加载数据
    loadData = (jsonResult) => {
        console.log("formRef", this.formRef.current);
        const { Wgjsrq,PlanDate ,OneChannel,TwoChannelSource} = jsonResult.data || {};
        this.formRef.current.setFieldsValue({
            planDate: PlanDate ? moment(PlanDate) : PlanDate,
            lastSubmissionChannel: jsonResult.data.LastSubmissionChannel,
            oneChannel: jsonResult.data.OneChannel,
            twoChannel: jsonResult.data.TwoChannel,
            referrerJobNumber: jsonResult.data.ReferrerJobNumber,
            referrerName: jsonResult.data.ReferrerName,
            zggh: jsonResult.data.Zggh,
            zgxm: jsonResult.data.Zgxm,
            tjlx: jsonResult.data.Tjlx,
            tjlx: jsonResult.data.Tjlx,
            bdd: jsonResult.data.Bdd,
            ldht: jsonResult.data.Ldht,
            sjfwzt: jsonResult.data.Sjfwzt,
            wgjsrq: Wgjsrq ? moment(Wgjsrq) : Wgjsrq,

            isReady: true,
            errorMessage
        });
        this.setState({
            //offerId: jsonResult.data.OfferId,
            tjlxSource: jsonResult.data.TjlxSource,
            bddSource: jsonResult.data.BddSource,
            ldhtSource: jsonResult.data.LdhtSource,
            sjfwztSource: jsonResult.data.SjfwztSource,
            oneChannelSource: jsonResult.data.OneChannelSource,
            twoChannelAllSource: TwoChannelSource,
            isReady: true,
            errorMessage,
            twoChannelSource:TwoChannelSource.filter(item => item.TextJson == OneChannel && OneChannel!=null),
            showReferrer:OneChannel=='2' //第一渠道=内部推荐则显示内部推荐人姓名和内部推荐人工号
        });

    };

    //第一渠道监听
    chanelSelectedValue = (value) => {
        if (value !== "") {
            console.log(value);
            let selected = this.state.twoChannelAllSource.filter(item => item.TextJson == value);
            this.setState({showReferrer:value=='2', twoChannelSource:selected});
            this.formRef.current.setFieldsValue({twoChannel:""});
        }
    };

    //提交表单
    onFinish = async (values) => {
        const clickTime = Date.now()
        console.log("this.lastClickTime", this.lastClickTime);
        if (!this.lastClickTime || Math.abs(this.lastClickTime - clickTime) > 2000) {
            this.lastClickTime = clickTime;

            console.log("用户输入", values);
            const fieldsValue = await this.formRef.current.validateFields();
            console.log("fieldsValue", fieldsValue);

            const params = {
                tenantId: this.state.tenantId,
                commonParamater: this.state.commonParamater,

                planDate: moment(fieldsValue.planDate).format('YYYY-MM-DD'),
                lastSubmissionChannel: fieldsValue.lastSubmissionChannel,
                oneChannel: fieldsValue.oneChannel,
                twoChannel: fieldsValue.twoChannel,
                referrerJobNumber: fieldsValue.referrerJobNumber,
                referrerName: fieldsValue.referrerName,
                zggh: fieldsValue.zggh,
                zgxm: fieldsValue.zgxm,
                tjlx: fieldsValue.tjlx,
                bdd: fieldsValue.bdd,
                ldht: fieldsValue.ldht,
                sjfwzt: fieldsValue.sjfwzt,
                wgjsrq: fieldsValue.wgjsrq != null ? moment(fieldsValue.wgjsrq).format('YYYY-MM-DD') : null
                //offerId: this.state.offerId
            };

            this.setState();
            const bodyString = JSON.stringify(params);
            console.log("bodyString", bodyString);
            axios
                .post("/api/ChangXinCunChu/SaveForm", bodyString,
                    {
                        headers: { "Content-Type": "application/json" }
                    })
                .then(res => {
                    console.log("保存长鑫存储res", res);
                    let errorMessage = "";
                    if (res.status == 200 && res.data.code == "200") {
                        errorMessage = "保存成功";
                        this.setState({ isLoading: false, isReady: true, errorMessage });
                        window.parent.postMessage(
                            {
                                msgCode: this.state.messageCode,
                                Code: 200,
                                Message: '保存成功',
                                isClose: true,
                            },
                            '*'
                        );
                    }
                    else {
                        errorMessage = "保存失败";
                        this.setState({ isLoading: false, isReady: true, errorMessage });
                    }
                })
                .catch(reason => {
                    this.setState({ isLoading: false, isReady: true, errorMessage: "保存失败，请联系管理员！" });
                })
                .finally(
                );

        }
    };

    //渲染界面
    render() {
        console.log("长鑫存储this.state", this.state);
        const dateFormat = 'YYYY-MM-DD';

        return (<div style={{ overflowY: "auto", paddingBottom: "12px" ,display:this.state.showElem?'':'none'}}>
            <Form name='formName' onFinish={this.onFinish} ref={this.formRef} {...formLayout}>
                {this.state.errorMessage != "" ? (<div style={{ textAlign: "center", padding: "32px" }}><span style={{ color: "red" }}>{this.state.errorMessage}</span></div>)
                    : (<div>
                        <div style={{ paddingTop: '18px' }}>
                        </div>
                        <Form.Item label="预计入职日期" name="planDate" required 
                            rules={[
                                {
                                    required: true,
                                    message: '请选择日期',
                                },
                            ]}>
                            <DatePicker style={{ float: "left" }} placeholder="---请选择---" format={dateFormat} />
                        </Form.Item>
                        <Form.Item label="招聘渠道" required name="lastSubmissionChannel" rules={[{ required: true, message: '请输入招聘渠道' }]} >
                            <Input></Input>
                        </Form.Item>
                        <Form.Item label="第一渠道" required name="oneChannel" rules={[{ required: true, message: '请选择第一渠道' }]} >
                            <Select showSearch
                                placeholder="---请选择第一渠道---"
                                onChange={this.chanelSelectedValue}>
                                {this.state.oneChannelSource.map((opt) => (
                                    <Option key={opt.Value}>{opt.Text}</Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item label="第二渠道" required name="twoChannel" rules={[{ required: true, message: '请选择第二渠道' }]} >
                            <Select showSearch
                                placeholder="---请选择第二渠道---">
                                {this.state.twoChannelSource.map((opt) => (
                                    <Option key={opt.Value}>{opt.Text}</Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item label="推荐人工号" name="referrerJobNumber" rules={[{ required: this.state.showReferrer?true:false, message: '请输入推荐人工号' }]} style={{display:this.state.showReferrer?'':'none'}}>
                            <Input ></Input>
                        </Form.Item>
                        <Form.Item label="推荐人姓名" name="referrerName" rules={[{ required: this.state.showReferrer?true:false, message: '请输入推荐人姓名' }]} style={{display:this.state.showReferrer?'':'none'}}>
                            <Input></Input>
                        </Form.Item>
                        <Form.Item label="主管工号" required name="zggh" rules={[{ required: true, message: '请输入主管工号' }]} >
                            <Input></Input>
                        </Form.Item>
                        <Form.Item label="主管姓名" required name="zgxm" rules={[{ required: true, message: '请输入主管姓名' }]} >
                            <Input></Input>
                        </Form.Item>
                        <Form.Item label="体检类型" required name="tjlx" rules={[{ required: true, message: '请选择体检类型' }]} >
                            <Select showSearch
                                placeholder="---请选择体检类型---">
                                {this.state.tjlxSource.map((opt) => (
                                    <Option key={opt.Value}>{opt.Text}</Option>
                                ))}
                            </Select>
                        </Form.Item>

                        <Form.Item label="报到地" required name="bdd" rules={[{ required: true, message: '请选择报到地' }]} >
                            <Select showSearch
                                placeholder="---请选择报到地---">
                                {this.state.bddSource.map((opt) => (
                                    <Option key={opt.Value}>{opt.Text}</Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item label="劳动合同签约主体" required name="ldht" rules={[{ required: true, message: '请选择劳动合同签约主体' }]} >
                            <Select showSearch
                                placeholder="---请选择劳动合同签约主体---">
                                {this.state.ldhtSource.map((opt) => (
                                    <Option key={opt.Value}>{opt.Text}</Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item label="实际服务主体" required name="sjfwzt" rules={[{ required: true, message: '请选择实际服务主体' }]} >
                            <Select showSearch
                                placeholder="---请选择实际服务主体---">
                                {this.state.sjfwztSource.map((opt) => (
                                    <Option key={opt.Value}>{opt.Text}</Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item label="外挂结束日期" name="wgjsrq" >
                            <DatePicker name="wgjsrq" style={{ float: "left" }} placeholder="---请选择日期---" format="YYYY/MM/DD" />
                        </Form.Item>
                        <Form.Item style={{ textAlign: "center" }}>
                            <Button type="prmary" htmlType="submit" >提交</Button>
                        </Form.Item>
                    </div>)}
            </Form>
        </div>
        )
    }
}